module.exports = __webpack_public_path__ + "static/media/5.a2c487f6.JPG";